import {
  fetchWrapper,
  handleResponse,
  hcUrlV3,
  buildOpts,
  formatBody,
} from 'services/RequestService/helpers';

const createNpsSurvey = async ({ params: { rating, comment } }) => {
  const response = await fetchWrapper(
    hcUrlV3('/nps'),
    buildOpts({
      method: 'POST',
      body: formatBody({ rating, comment }),
    })
  );

  return handleResponse(response);
};

const getNpsSurvey = async () => {
  const response = await fetchWrapper(hcUrlV3('/nps'), buildOpts());

  return handleResponse(response);
};

export { createNpsSurvey, getNpsSurvey };
